/** The header's memoised leaf: its own subscriptions, its own model. */
import React from 'react';

import PlayHeaderView from './View';
import {usePlayHeaderModel} from './model';

export default React.memo(function PlayHeader() {
  return <PlayHeaderView {...usePlayHeaderModel()} />;
});
